import axios from '@/libs/api.request'
import { getToken } from '@/libs/util'
import config from '@/config'

// 数据库管理基础URL
const baseDBUrl = config.baseDBUrl
const dbBaseUrl = baseDBUrl + '/database/api/v1/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getInstanceList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/',
    headers: baseHeaders,
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const getMySQLParamList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/parameter/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getProcessList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/processlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceUserList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/userlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceAllUserList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/all_userlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const deleteInstance = (id) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/' + id + '/',
    method: 'delete'
  })
}

export const deleteMySQLParam = (id) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/parameter/' + id + '/',
    method: 'delete'
  })
}

export const pushInstance = (data, id) => {
  let url = dbBaseUrl + 'mysql/instance/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const pushMySQLParam = (data, id) => {
  let url = dbBaseUrl + 'mysql/parameter/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const resetUserPassword = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/password/reset/',
    data: data,
    method: 'POST'
  })
}

export const deleteInstanceUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/user/remove/',
    data: data,
    method: 'POST'
  })
}

export const lockInstanceUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/user/lock/',
    data: data,
    method: 'POST'
  })
}

export const unlockInstanceUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/user/unlock/',
    data: data,
    method: 'POST'
  })
}

export const getPrivList = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/privilege/',
    data: data,
    method: 'POST'
  })
}

export const revokePrivilege = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/privilege/revoke/',
    data: data,
    method: 'POST'
  })
}

export const showDatabaseList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/database/show/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getDatabaseList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/database/list/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const addDatabase = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/database/add/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const alterDatabase = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/database/alter/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const removeDatabase = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/database/remove/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getParamList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/current/parameter/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const setParam = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/current/parameter/set/',
    data: data,
    method: 'POST'
  })
}

export const getInstanceLogList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/server/log/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getOpsLogList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instancelog/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceStats = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/stats/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getBackUpConfigList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/backup/config/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getBackUpList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/backup/info/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const pushBackUpConfig = (data, id) => {
  let url = dbBaseUrl + 'mysql/backup/config/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const manualBackup = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/manual/backup/',
    data: data,
    method: 'POST'
  })
}

export const backupUrl = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/backup/url/',
    data: data,
    method: 'POST'
  })
}

export const getBackUpLog = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/backup/log/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const createUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/user/create/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const addPrivs = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/privilege/add/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getMigrateList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/migrate/info/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getTableList = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/table/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const pushMigrate = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/migrate/info/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getMigrateLog = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/migrate/log/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const explainSQL = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/sql/explain/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const executeSQL = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/sql/execute/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getExecuteLog = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/execute/log/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const showTableList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/table/show/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const showColumnList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/column/show/',
    params: params,
    method: 'get'
  })
}

export const getColumnList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/column/get/',
    params: params,
    method: 'get'
  })
}

export const createTable = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/table/create/',
    data: data,
    method: 'post'
  })
}

export const alertTable = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/table/alter/',
    data: data,
    method: 'post'
  })
}

export const showCharacterList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/character/show/',
    params: params,
    method: 'get'
  })
}

export const showCharacterCollateList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/character/collate/show/',
    params: params,
    method: 'get'
  })
}

export const getCommonSQL = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/common/sql/',
    params: params,
    method: 'get'
  })
}

export const showViewList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/view/show/',
    params: params,
    method: 'get'
  })
}

export const getViewData = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/view/get/',
    params: params,
    method: 'get'
  })
}

export const createView = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/view/create/',
    data: data,
    method: 'post'
  })
}

export const alterView = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/view/alter/',
    data: data,
    method: 'post'
  })
}

export const showFuncList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/routine/show/',
    params: params,
    method: 'get'
  })
}

export const getFuncData = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/routine/get/',
    params: params,
    method: 'get'
  })
}

export const createFunc = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/routine/create/',
    data: data,
    method: 'post'
  })
}

export const alterFunc = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/routine/alter/',
    data: data,
    method: 'post'
  })
}
export const getTableInfo = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/table/info/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}
export const showEventList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/event/show/',
    params: params,
    method: 'get'
  })
}

export const getEventData = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/event/get/',
    params: params,
    method: 'get'
  })
}

export const createEvent = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/event/create/',
    data: data,
    method: 'post'
  })
}

export const alterEvent = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/event/alter/',
    data: data,
    method: 'post'
  })
}
